import { MaybeAsync } from '@angular/router';
import { inject } from '@angular/core';
import { AttachmentsUploadingWarningService } from '@shared/guards/attachments-uploading-warning/attachments-uploading-warning.service';
import { MatDialog } from '@angular/material/dialog';
import { AttachmentsUploadingWarningDialogComponent } from '@shared/guards/attachments-uploading-warning/component/attachments-uploading-warning-dialog.component';

export const attachmentsUploadingWarningGuard = (): MaybeAsync<boolean> => {
  const service = inject(AttachmentsUploadingWarningService);

  if (service.attachmentsAreUploading()) {
    return inject(MatDialog)
      .open(AttachmentsUploadingWarningDialogComponent)
      .afterClosed();
  }

  return true;
};
